import { useFetch, PageHeader, Panel, Tag } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { fmtTime } from "@/lib/api";
import CommandBrain from "@/components/CommandBrain";
import Custodian from "@/components/Custodian";
import CommandChat from "@/components/CommandChat";

export default function Command() {
  const { data, error, loading, reload } = useFetch("/command/diagnosis");
  return <div className="space-y-6" data-testid="command-center">
    <PageHeader title="NEXUS Command" sub="Central oversight · Evidence before action"
      right={<Button onClick={reload} disabled={loading}>Inspect system</Button>} />
    <Panel title="Operational boundary">
      <div className="flex flex-wrap gap-2"><Tag tone="blue">Deterministic diagnostics</Tag><Tag>Optional OpenAI adviser below</Tag><Tag>No live code changes</Tag><Tag>No order authority</Tag></div>
      <p className="mt-3 text-sm text-muted-foreground">Operational evidence is checked locally. OpenAI reviews require a separately configured key and activation below. Autonomous repair, strategy generation and broker execution are not enabled by this page.</p>
    </Panel>
    <CommandBrain />
    <Custodian />
    <CommandChat />
    {error && <Panel title="Inspection unavailable"><p role="alert">{error}</p><p className="mt-2 text-sm text-muted-foreground">Any previous assessment below is historical; do not treat it as current system health.</p></Panel>}
    {loading && !data && <p role="status">Reading operational evidence…</p>}
    {data && <>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">{data.desks.map(d => <Panel key={d.id} title={d.name} right={<Tag tone={d.status === "available" ? "blue" : "muted"}>{d.status}</Tag>}>
        <p className="text-sm text-muted-foreground">{d.purpose}</p>
      </Panel>)}</div>
      <Panel title="Evidence & remediation plan" right={<Tag tone={error ? "warn" : data.assessment === "blocked" ? "down" : "warn"}>{error ? "Historical assessment" : data.assessment}</Tag>}>
        <p className="mb-4 text-xs text-muted-foreground">Evaluated {fmtTime(data.evaluated_at)} · Recommendations only; no action executed.</p>
        <div className="space-y-4">{data.findings.map(f => <div key={f.code} className="rounded border border-border p-4">
          <div className="flex flex-wrap items-center gap-2"><Tag tone={f.severity === "critical" ? "down" : f.severity === "warning" ? "warn" : "muted"}>{f.severity}</Tag><span className="font-medium">{f.title}</span></div>
          <p className="mt-2 text-sm text-muted-foreground">{f.recommended_action}</p>
          <p className="mt-2 font-mono text-xs text-muted-foreground">{f.code} · {f.desk}</p>
        </div>)}</div>
      </Panel>
    </>}
  </div>;
}
